import type { ComponentProps } from 'react'
import { View } from 'react-native'

export function MesaHeader(props: ComponentProps<typeof View>) {
  return (
    <View
      {...props}
      style={[
        {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          overflow: 'hidden',
          height: 201,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
        },
        props.style,
      ]}
    />
  )
}
